import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import styled from 'styled-components'

import { Submit } from '@/components/UberForm'

export const TitleContainer = styled.div`
	display: flex;
	align-items: center;
	font-size: 160%;
	border-bottom: 1px solid ${({ theme }) => theme.colors.layout.borderColor};
	background-color: #fafafa;
	padding-left: 20px;
`

export const TitleText = styled.div`
	margin: 10px 15px;
	flex: 1;
`

export const TitleIcon = styled(FontAwesomeIcon)<{ color?: string }>`
	color: ${(props) => props.color || '#333'};
`

export const TitleActions = styled.div`
	display: flex;
	flex: 0;
	button {
		margin: 0;
		white-space: nowrap;
		background-color: #f8f8f8;
		color: #333;
		border-radius: 0;
		border: none;
		border-left: 1px solid ${(props) => props.theme.colors.layout.borderColor};
		line-height: 22px;
	}
`
export const Wrapper = styled.div`
	display: flex;
	margin: 0 -20px;
	align-items: flex-end;
	flex-wrap: wrap;
`
export const Row = styled.div`
	display: flex;
	width: 100%;
	align-items: flex-end;
`

export const Column = styled.div<{ width?: string }>`
	width: ${(props) => props.width ?? '25%'};
	padding: 0 20px;
	margin-bottom: 5px;
	box-sizing: border-box;
`

export const TreeContainer = styled.div`
	overflow: auto;
	height: 100%;
	display: flex;
	border-top: 1px solid #ddd;
`

export const ViewContainer = styled.div`
	flex-direction: column;
	overflow: auto;
	height: 100%;
	display: flex;
	background: white;
	border-top: 1px solid #ddd;
`

export const Action = styled.div`
	opacity: 0.5;
	cursor: pointer;
	margin-left: 5px;

	&:hover {
		opacity: 1;
	}
`

export const CellValue = styled.div`
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
`
export const AuditWrapper = styled.div`
	display: flex;
	font-size: 14px;
`
export const SubmitNaming = styled(Submit)`
	height: 62px;
	align-items: center;
	font-size: 1rem;
`
export const ColumnBig = styled.div`
	width: 40%;
	padding: 0 10px;
`
export const ColumnSmall = styled.div`
	width: 20%;
	padding: 0 10px;
`
export const Container = styled.div`
	flex-grow: 1;
	display: flex;
	flex-direction: column;
	background-color: ${(props) =>
		props.theme.colors.layout.treePanel.backgroundColor};
`
export const TreeTitleText = styled.div`
	letter-spacing: 1px;
	text-transform: uppercase;
	padding: 8px 12px;
	border-bottom: 1px solid #ddd;
	background: ${(props) =>
		props.theme.colors.layout.treePanel.headerBackgroundColor};
`

export const dataGridStyles = {
	border: 'none',
	'& .MuiDataGrid-cell': {
		borderBottom: '1px solid rgba(224, 224, 224, 1)',
		padding: '4px 8px',
		color: 'rgba(0, 0, 0, 0.87)',
	},
	'& .MuiDataGrid-columnHeaders': {
		backgroundColor: '#265560',
		borderBottom: '1px solid rgba(224, 224, 224, 1)',
		minHeight: '40px',
		maxHeight: '40px',
		'& .MuiDataGrid-filler': {
			backgroundColor: '#265560',
			border: 'none',
		},
		'& .MuiDataGrid-columnSeparator': {
			opacity: 1,
		},
		'& .MuiDataGrid-columnHeader': {
			backgroundColor: '#265560',
			color: '#fff',
			border: 'none',
			borderBottom: 'none',
			borderLeft: 'none',
			borderTop: 'none',
			padding: '4px 8px',
			minHeight: '40px',
			maxHeight: '40px',
			opacity: 1,
			'&:focus': {
				outline: 'none',
				opacity: 1,
				'& .MuiDataGrid-columnSeparator': {
					opacity: 1,
				},
			},
			'&:focus-visible': {
				outline: 'none',
				opacity: 1,
				'& .MuiDataGrid-columnSeparator': {
					opacity: 1,
				},
			},
			'&:active': {
				opacity: 1,
				'& .MuiDataGrid-columnSeparator': {
					opacity: 1,
				},
			},
			'& .MuiDataGrid-columnSeparator': {
				opacity: 1,
			},
			'& > *': {
				border: 'none',
				opacity: 1,
			},
			'& .MuiDataGrid-columnHeaderDraggableContainer': {
				border: 'none',
				opacity: 1,
			},
			'& .MuiDataGrid-columnHeaderTitleContainer': {
				border: 'none',
				opacity: 1,
			},
			'& .MuiDataGrid-iconButtonContainer': {
				opacity: 1,
			},
			'& .MuiDataGrid-menuIcon': {
				opacity: 1,
			},
			'& .MuiDataGrid-columnHeaderTitle': {
				color: '#fff',
				fontWeight: 'bold',
			},
			'& .MuiDataGrid-sortIcon': {
				color: '#fff',
			},
			'& .MuiSvgIcon-root': {
				color: '#fff',
			},
			'& svg': {
				color: '#fff',
			},
		},
	},
}
